const scrollToTop = () => {
  try {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  } catch (e) {
    window.scrollTo(0, 0);
  }
};

export default scrollToTop;
